<template>
  <v-card class="pa-5" height="475" width="705">
    <v-card-text class="mt-5">
      <v-avatar :color="randomColor">
        <img v-if="isAvatar" :src="avatarPath" alt="picture" />
        <span v-else class="_light_grey--text headline">{{ photoWord }}</span>
      </v-avatar>
      <span class="ma-5 text-h6 font-weight-black">{{ data.userName }}</span>
      <div class="my-5 _grey--text h6">{{ $t(option + 'Description') }}</div>
      <v-rating
        v-if="option === 'comment'"
        class="my-5"
        v-model="data.rating"
        color="_blue"
        background-color="_blue"
        dense
        hover
        size="30"
      ></v-rating>
      <br v-else />
      <v-textarea v-model="data.comment" :label="$t(option + 'Hint')" outlined counter maxlength="300"></v-textarea>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="_blue" outlined text @click="$emit('cancel')">{{ $t('cancel') }}</v-btn>
      <v-btn color="_blue" class="white--text" @click="$emit('submit')" :disabled="submitDisable">{{ $t('submit') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import CommVar from '@/method/commVar';

export default {
  name: 'EditComment',
  props: {
    data: { type: Object, default: () => ({ userName: '' }) },
    option: { type: String, default: 'comment' },
  },
  data: () => ({
    randomColor: `rgb( ${Math.floor(CommVar.random() * 256)}, ${Math.floor(CommVar.random() * 256)}, ${Math.floor(CommVar.random() * 256)})`,
  }),
  computed: {
    submitDisable() {
      if (this.option === 'response') return false;
      return this.data.rating === undefined;
    },
    photoWord() {
      return this.data.userName[0];
    },
    isAvatar() {
      return Object.prototype.hasOwnProperty.call(this.data, 'avatar');
    },
    avatarPath() {
      return `${process.env.VUE_APP_S3_URL}public/avatar/${this.data.avatar}`;
    },
  },
  methods: {},
};
</script>
